import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import styled from "styled-components";

const stripePromise = loadStripe("pk_test_XXXXXXXXXXXXXXXXXXXXXXXX"); // Replace with your Stripe public key

// 🔥 Styled Components
const PaywallContainer = styled.div`
  background: linear-gradient(to bottom, #FF7C24, #fff);
  font-family: 'Nunito Sans', sans-serif;
  color: #232830;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 40px 20px;
`;

const Mascot = styled.div`
  font-size: 80px;
  animation: bounce 2s infinite;
  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-15px); }
  }
`;

const Heading = styled.h1`
  font-size: 26px;
  font-weight: 800;
  color: #232830;
  margin-bottom: 12px;
`;

const SubText = styled.p`
  font-size: 16px;
  margin: 8px 0 24px;
  color: #333;
  max-width: 400px;
`;

const CorrectAnswersBox = styled.div`
  background-color: #232830;
  color: #fff;
  padding: 12px 20px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
`;

const TryButton = styled.button`
  background-color: #FF7C24;
  color: #fff;
  padding: 14px 28px;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    transform: scale(1.05);
    background-color: #000;
  }
`;

const SkipButton = styled.button`
  background: none;
  color: #232830;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 40px;
`;

const BenefitsList = styled.ul`
  list-style: none;
  padding: 0;
  text-align: left;
  max-width: 400px;
  margin: 20px auto;
  li {
    font-size: 16px;
    margin-bottom: 10px;
    &:before {
      content: '✨';
      margin-right: 8px;
    }
  }
`;

const Paywall = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const numberOfOnboardingActivationCorrectAnswers = location.state?.numberOfOnboardingActivationCorrectAnswers || 0;

  const handleSubscribe = () => {
    window.location.href = "https://buy.stripe.com/eVa29y1Ig8zsgFycMZ";
  };

  const handleSkip = () => {
    navigate("/post-activation-quote", {
      state: { numberOfOnboardingActivationCorrectAnswers }
    });
  };

  return (
    <PaywallContainer>
      <Mascot>📈</Mascot>


      <Heading>You're off to a great start!</Heading>

      <CorrectAnswersBox>
  🏆 Your score :  <span style={{ color: '#FF0000' }}>{numberOfOnboardingActivationCorrectAnswers}</span> out of 5!
</CorrectAnswersBox>


      <SubText>
        Imagine what you can achieve with full access to FinTorro Pro!
        Boost your skills, master the markets, and build financial freedom — one lesson at a time.
      </SubText>

      <TryButton onClick={handleSubscribe}>Try 2 Weeks Free Trial</TryButton>

      <BenefitsList>
      <li>⚡ Unlimited Lessons & Practice</li>
<li>⚡ Learn with AI</li>
<li>⚡ 10,000+ Interactive Lessons</li>
<li>⚡ Crypto, Forex, Stocks & More</li>
<li>⚡ Join Challenges & Earn Rewards</li>

      </BenefitsList>

      <SkipButton onClick={handleSkip}>Skip for now</SkipButton>
    </PaywallContainer>
  );
};

export default Paywall;


// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { loadStripe } from "@stripe/stripe-js";
// import styled from "styled-components";

// const stripePromise = loadStripe("pk_test_XXXXXXXXXXXXXXXXXXXXXXXX"); // Replace with your Stripe public key

// const PaywallContainer = styled.div`
//   background: linear-gradient(to bottom, #FF7C24, #fff);
//   font-family: 'Nunito Sans', sans-serif;
//   color: #232830;
//   min-height: 100vh;
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
//   align-items: center;
//   text-align: center;
//   padding: 40px 20px;
// `;

// const Mascot = styled.div`
//   font-size: 80px;
//   animation: bounce 2s infinite;
//   @keyframes bounce {
//     0%, 100% { transform: translateY(0); }
//     50% { transform: translateY(-15px); }
//   }
// `;

// const Heading = styled.h1`
//   font-size: 24px;
//   margin-bottom: 16px;
// `;

// const SubText = styled.p`
//   font-size: 16px;
//   margin-bottom: 24px;
//   color: #555;
// `;

// const TryButton = styled.button`
//   background-color: #232830;
//   color: #fff;
//   padding: 14px 28px;
//   border: none;
//   border-radius: 12px;
//   font-size: 18px;
//   font-weight: bold;
//   margin-bottom: 20px;
//   cursor: pointer;
//   transition: all 0.3s ease;
//   &:hover {
//     transform: scale(1.05);
//     background-color: #000;
//   }
// `;

// const SkipButton = styled.button`
//   background: none;
//   color: #232830;
//   font-size: 14px;
//   text-decoration: underline;
//   cursor: pointer;
// `;

// const BenefitsList = styled.ul`
//   list-style: none;
//   padding: 0;
//   text-align: left;
//   max-width: 400px;
//   margin: 20px auto;
//   li {
//     font-size: 16px;
//     margin-bottom: 10px;
//     &:before {
//       content: '✨';
//       margin-right: 8px;
//     }
//   }
// `;

// const Paywall = () => {
//   const navigate = useNavigate();

//   // const handleSubscribe = async () => {
//   //   const stripe = await stripePromise;
//   //   const response = await fetch("/create-checkout-session", { method: "POST" });
//   //   const session = await response.json();
//   //   await stripe.redirectToCheckout({ sessionId: session.id });
//   // };

//   const handleSubscribe = () => {
//     window.location.href = "https://buy.stripe.com/eVa29y1Ig8zsgFycMZ";
//   };
  

//   const handleSkip = () => {
//     navigate("/post-activation-quote");
//   };

//   return (
//     <PaywallContainer>
//       <Mascot>🧠</Mascot>
//       <Heading>Try FinTorro Pro for Free</Heading>
//       <SubText><p>You're more likely to be successful in financial markets with learning as life long skill!</p>
//       </SubText>
//       <TryButton onClick={handleSubscribe}>Try 2 Weeks Free Trial</TryButton>
//       <BenefitsList>
//         <li>Unlimited Lessons & Practice</li>
//         <li>Learn with AI</li>
//         <li>10,000+ Interactive Lessons</li>
//         <li>Crypto, Forex, Stocks & More</li>
//         <li>Join Challenges & Earn Rewards</li>
//       </BenefitsList>
//       <SkipButton onClick={handleSkip}>Skip for now</SkipButton>
//     </PaywallContainer>
//   );
// };

// export default Paywall;
